import Vue from "vue";
import Vuetify from "vuetify";
import de from "vuetify/src/locale/de";
import en from "vuetify/src/locale/en";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/es5/util/colors";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
		options: {
			customProperties: true,
		},
	themes: {
		light: {
			primary: colors.deepOrange.base,
			secondary: colors.amber.base,
			accent: colors.lightGreen.base,
			error: colors.red.darken2,
			warning: colors.amber.base,
			info: colors.blue.base,
			success: colors.green.base,
			anchor: "#0e5109"
		},
	},
  },
	lang: {
		locales: { de, en },
		current: "de",
	},
  icons: {
	iconfont: "fa",
  },
});
